import Lottie from "lottie-react";
import React, { Fragment, useEffect, useState } from "react";
import { SimpleLightbox } from "../Cards/VideoCardDeck/SimpleLightbox/SimpleLightbox";
import { YouTubeVideoEmbed } from "../Cards/VideoCardDeck/YouTubeVideoEmbed";
import { getMediaType, getVideoType } from "./utils";
export const M44MediaViewer = ({ mediaFileUrl, posterUrl, isVideoLooping = true, alt, forcedMediaType, mediaWidth, mediaHeight, mediaMaxWidth, mediaMaxHeight, mediaClassname, addDivWrapper = true, }) => {
    const [animation, setAnimation] = useState();
    useEffect(() => {
        if (mediaFileUrl?.includes("json")) {
            fetch(mediaFileUrl)
                .then((response) => response.json())
                .then((jsonData) => {
                setAnimation(jsonData);
            })
                .catch((error) => {
                console.error(error);
            });
        }
    }, [mediaFileUrl]);
    const isMediaTypeUndefined = (() => !mediaFileUrl && !forcedMediaType)();
    if (isMediaTypeUndefined) {
        return React.createElement(React.Fragment, null, "No media file provided");
    }
    const mediaType = (() => forcedMediaType || getMediaType(mediaFileUrl))();
    const wrapperClassName = (() => {
        if (WrapperEl === Fragment) {
            return "";
        }
        if (!mediaClassname) {
            return "media-viewer";
        }
        return `media-viewer${mediaClassname ? ` ${mediaClassname}` : ""}`;
    })();
    if (mediaType === "image") {
        return (React.createElement(WrapperEl, { addDivWrapper: addDivWrapper, className: wrapperClassName },
            React.createElement("img", { src: mediaFileUrl, alt: alt })));
    }
    if (mediaType === "video") {
        const videoType = getVideoType(mediaFileUrl);
        return (React.createElement(WrapperEl, { addDivWrapper: addDivWrapper, className: wrapperClassName },
            React.createElement("video", { poster: posterUrl, autoPlay: true, muted: true, playsInline: true, loop: isVideoLooping },
                React.createElement(ConditionalVideoSource, { mediaFileUrl: mediaFileUrl, type: videoType }))));
    }
    if (mediaType === "youtube-iframe" && mediaFileUrl) {
        return (React.createElement(SimpleLightbox, { className: "trending-videos__lightbox-trigger" },
            React.createElement(YouTubeVideoEmbed, { videoUrl: mediaFileUrl, width: mediaWidth, height: mediaHeight, maxWidth: mediaMaxWidth, maxHeight: mediaMaxHeight })));
    }
    if (mediaType === "lottie-json") {
        return (React.createElement(WrapperEl, { addDivWrapper: addDivWrapper, className: wrapperClassName },
            React.createElement(Lottie, { animationData: animation, loop: true, rendererSettings: {
                    filterSize: {
                        width: "200%",
                        height: "200%",
                        x: "-50%",
                        y: "-50%",
                    },
                } })));
    }
    return React.createElement(React.Fragment, null);
};
const ConditionalVideoSource = ({ mediaFileUrl, type, }) => {
    if (!mediaFileUrl) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement("source", { src: mediaFileUrl, type: type });
};
const WrapperEl = ({ addDivWrapper = false, className, children, }) => {
    if (!addDivWrapper) {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement("div", { className: className }, children);
};
